import React, { memo } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = ['Strutturi lezioni di tango più chiare, professionali e coinvolgenti', 'Mantieni alta la motivazione degli studenti più facilmente', 'Aiuti i tuoi allievi a progredire in modo più visibile e costante', 'Risparmi tempo nella preparazione delle lezioni', 'Ti senti finalmente un insegnante più sicuro, organizzato e valorizzato'];
  return <section className="py-16 md:py-24 bg-white px-4" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-193">
            Ed è proprio per questo che abbiamo creato il Metodo Completo per
            Insegnanti di Tango
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-194">
            Un sistema pratico, completo e immediatamente applicabile per
            aiutarti a insegnare tango con più metodo, più sicurezza e più
            risultati.
          </p>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-red-50 rounded-3xl border border-amber-100 p-8 md:p-12 shadow-lg" data-id="element-195">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-196">
            {benefits.map((benefit, index) => <div key={index} className={`bg-white rounded-xl p-5 flex items-start space-x-4 shadow-sm ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-197">
                <CheckCircle2Icon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-198" />
                <p className="text-stone-800 font-medium text-lg" data-id="element-199">{benefit}</p>
              </div>)}
          </div>
        </div>

        <p className="text-center text-stone-600 italic mt-10 text-lg max-w-2xl mx-auto" data-id="element-200">
          Non si tratta solo di insegnare meglio. Si tratta di far vivere il
          tango in modo più profondo, coinvolgente e memorabile.
        </p>
      </div>
    </section>;
}